export default __webpack_public_path__ + "static/media/blood2.32907ced.jpeg";